import { formatPct } from "../../lib/format";

// Budget utilization bar. Color shifts to amber/red as utilization rises.
export default function ProgressBar({
  ratio,
  showLabel = true,
}: {
  ratio: number;
  showLabel?: boolean;
}) {
  const pct = Math.max(0, ratio);
  const width = Math.min(100, pct * 100);
  const color =
    pct > 1 ? "bg-critical" : pct >= 0.9 ? "bg-warn" : "bg-positive";
  return (
    <div className="flex items-center gap-2">
      <div className="h-2 flex-1 overflow-hidden rounded-full bg-ink-200" role="progressbar" aria-valuenow={Math.round(width)}>
        <div className={`h-full rounded-full ${color}`} style={{ width: `${width}%` }} />
      </div>
      {showLabel && (
        <span className={`w-12 shrink-0 text-right text-xs font-medium tabular-nums ${pct > 1 ? "text-critical" : "text-ink-600"}`}>
          {formatPct(ratio)}
        </span>
      )}
    </div>
  );
}
